/* eslint-disable no-unused-expressions,object-curly-newline,no-unused-vars */
/* global G */
import { asyncPipeSpread } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import applyAdminFilters from 'app/_shared/action/partial/applyAdminFilters'

const removeElements = (array, indexes) => array.reduce((acc, item, index) => {
  !indexes.includes(index) && acc.push(item)
  return acc
}, [])

const hideListColumns = (module, listKey, columns = []) => async (components, ...args) => {
  const { [listKey]: list } = components
  const listState = list[G.STATE]
  const { structure, label, size } = list[G.PROPS]
  const props = { structure, label, size }

  Object.keys(props).forEach((key) => {
    listState[key] = removeElements(props[key], columns)
  })

  console.log(listState)

  return [components, ...args]
}

/**
 * Organisation Action Index
 *
 * @param {Gaia.Component.Spec} module current module composition
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
export default module => () => async (...args) => asyncPipeSpread(
  // asyncPipeSpreadIf(() => settings.suppressSupportedBy)(
  //   hideListColumns(module, 'reqList', [3]),
  //   hideListColumns(module, 'csmList', [3]),
  // ),
  applyAdminFilters('csmList')(module),
)(find(module[G.STATE][G.ACTION][G.COMPONENT]), ...args)
